export default () => ({

    activeSpectacleSlug: '',
    availableSpectacleSlugs: [],

    init() {

        // noinspection JSUnresolvedReference
        this.availableSpectacleSlugs = JSON.parse(this.$root.dataset.availableSpectacleSlugs)

        // noinspection JSUnresolvedReference
        this.activeSpectacleSlug = this.$root.dataset.initialSpectacleSlug;

        if (window.location.hash) {

            let hashSlug = window.location.hash.substring(1);

            if (this.availableSpectacleSlugs.includes(hashSlug)) {
                this.activeSpectacleSlug = hashSlug;
            }
        }

        // noinspection JSUnresolvedReference
        this.$watch('activeSpectacleSlug', () => {

            const newHash = this.activeSpectacleSlug;

            history.replaceState(null, null, window.location.href.split('#')[0] + '#' + newHash);

        });

    }

})
